import { useEffect, useRef, useState } from "react";
import { ReactCrop, centerCrop, makeAspectCrop } from "react-image-crop";

import 'react-image-crop/dist/ReactCrop.css'
import DialogModal from "../../../Modals/dialogModal";

import { logOut, uploadProfilePicture } from '../../../../Services/User.js'


const CropImg = (props) => {

    const [src, setSrc] = useState(null);
    const [crop, setCrop] = useState({ aspect: 1 / 1 });
    const [rotate, setRotate] = useState(0)
    const [aspect, setAspect] = useState(1 / 1)
    const [image, setImage] = useState(null);
    const [output, setOutput] = useState(null);



    const cropImageNow = async () => {
        if (!crop.width || !crop.height) {
            setModalErrorMsg("Seleccione el recorte de la imagen, clickeando o presionando, y arrastrando sobre la misma.");
            setShowErrorModal(true);
            return;
        }

        const canvas = document.createElement('canvas');

        let $img = document.getElementById('img-on-modal');
        
        const scaleX = $img.naturalWidth / $img.width;
        const scaleY = $img.naturalHeight / $img.height;
        canvas.width = crop.width;
        canvas.height = crop.height;
        const ctx = canvas.getContext('2d');

        const pixelRatio = window.devicePixelRatio;
        canvas.width = crop.width * pixelRatio;
        canvas.height = crop.height * pixelRatio;
        ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        ctx.imageSmoothingQuality = 'high';

        

        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width,
            crop.height,
        );

        const base64Image = canvas.toDataURL('image/jpeg');

        //Hago un fetch a la imagen encodeada
        const res = await fetch(base64Image);
        //Paso todo a un array buffer
        const buf = await res.arrayBuffer();
        //Creo el archivo para la subida
        const file = new File([buf], "prof.jpeg", {
            type: 'image/jpeg'
        });

        let rsp = await uploadProfilePicture(file);

        if (rsp.Error === true) {
            setModalErrorMsg("Ocurrió un error al cargar la imagen.");
            setShowErrorModal(true);
        }
        else {
            setShowSuccessModal(true);
        }


    };

    useState(() => {
        setSrc(props.src);

        let img = new Image();
        img.src = props.src;
        setImage(img);
    })

    const [showErrorModal, setShowErrorModal] = useState(false);
    const [modalErrorMsg, setModalErrorMsg] = useState("");

    const [showSuccessModal, setShowSuccessModal] = useState(false);

    return (
        <>
            <DialogModal showModal={props.showModal} setShowModal={props.setShowModal}
                contentWidth={"100%"}
                styles={{
                    container: {
                        height: "fit-content",
                        maxWidth: "80%",
                        width: "80%",
                        padding: 0
                    },
                    content: {
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        gap: "6px",
                        justifyContent: "space-between"
                    },
                    icon: {
                        filter: "grayscale(1) contrast(10)",
                        width: "30px",
                        maxWidth: "30px",
                        height: "unset",
                        maxHeight: "unset",
                        top: "0.25rem"
                    }
                }}
            >
                <div className=" dialog-modal-container" >
                    <h1 className={'modalHeader bc-green'} style={{}}>Recortar Imagen</h1>
                    <div className="profile-crop-container">
                        <ReactCrop src={src} crop={crop} onChange={setCrop} aspect={aspect}>
                            <img src={src} style={{ maxWidth: '70vw', maxHeight: '80vh' }} id='img-on-modal'/>
                        </ReactCrop>
                    </div>
                </div>
                <button className="green-btn" onClick={cropImageNow}>Confirmar</button>
            </DialogModal>
            <DialogModal showModal={showErrorModal} setShowModal={setShowErrorModal}>
                <h3 style={{ color: "black" }}>{modalErrorMsg}</h3>
            </DialogModal>
            <DialogModal showModal={showSuccessModal} setShowModal={setShowSuccessModal} showClose={false}
                styles={{
                    container: {
                        height: "fit-content"
                    },
                    content: {
                        display: "flex",
                        flexDirection: "column"
                    },
                    icon: {
                        filter: "grayscale(1) contrast(10)",
                    }
                }}
            >
                <h3 style={{ color: "black" }}>Se actualizaron los datos correctamente. Luego de aceptar deber&aacute; volver a ingresar.</h3>
                <button className={'green-btn setpointer'}
                    style={{
                        marginInline: "auto",
                        transition: "filter .7s, background-color 0s",
                        position: "absolute",
                        left: "5%",
                        right: "5%",
                        bottom: 0,
                    }}
                    onClick={() => {logOut(); window.location.reload();}}>Aceptar</button>
            </DialogModal>
        </>
    );
}

export default CropImg;